import type { AxiosError } from 'axios'

import { config } from '@/lib/helpers/config.helpers'

type ErrorResponse = {
  message: string
}

export const handleErrorMessage = (e: unknown) => {
  if ((e as AxiosError).isAxiosError) {
    // TODO: when connecting Sentry, we need to catch server errors here and sent to Sentry, with the exception of 404 and 403
    const axiosError = e as AxiosError<ErrorResponse>

    if (Array.isArray(axiosError.response?.data?.message)) {
      return axiosError.response.data.message[0] || 'Something went wrong, please try again'
    }

    return (
      axiosError.response?.data?.message ||
      axiosError.message ||
      'Something went wrong, please try again'
    )
  }

  if (config.environment === 'local') {
    return (e as Error).message
  } else {
    // TODO: send error manually to Sentry here
    return 'Something went wrong, please try again'
  }
}

export const handleBlobResponseErrorMessage = async (e: unknown): Promise<string> => {
  if ((e as AxiosError).isAxiosError) {
    const axiosError = e as AxiosError

    if (axiosError.response?.data instanceof Blob) {
      try {
        const text = await axiosError.response.data.text()
        const json = JSON.parse(text)
        return json.message ?? handleErrorMessage(e)
      } catch {
        return 'Something went wrong, please try again'
      }
    }
  }

  return handleErrorMessage(e)
}
